
<script>
import { mapGetters } from 'vuex';

export default {
	name: 'SelectionsMixin',
	props: ['routeParams'],
	data() {
		return {
			timeSpan: 'monthly',
			showIndices: false,
			selectedShareClass: '1',
			selectedObjectives: [],
			selectedAssetTypes: []
		};
	},
	computed: {
		...mapGetters([
			'appConfig',
			'getAudience'
		])
	},
	mounted() {
		//If a value exists in localStorage, use them
		const localStorageAdvisorShareClass = localStorage.getItem('advisor-afis-shareclass');
		const localStorageIndividualShareClass = localStorage.getItem('individual-afis-shareclass');
		if (this.getAudience === 'advisor' && localStorageAdvisorShareClass) this.selectedShareClass = localStorageAdvisorShareClass;
		if (this.getAudience === 'individual' && localStorageIndividualShareClass) this.selectedShareClass = localStorageIndividualShareClass;

		//if CG sends the state of the page through the f2 app config (User.Prefs), prefer those values over localStorage (no need to update localStorage).
		const appContext = this.appConfig.context;
		if (appContext.assetType) this.selectedAssetTypes = this.appConfig.context.assetType.split(',');
		if (appContext.objective) this.selectedObjectives = this.appConfig.context.objective.split(',');
		if (appContext.shareClassSymbol) this.selectedShareClass = appContext.shareClassSymbol;

		//If there are params on the url, override the f2app config values (User.Prefs) - but do not update either storage values.
		const routeParams = this.$props.routeParams;
		if (routeParams.assetTypes) this.selectedAssetTypes = routeParams.assetTypes;
		if (routeParams.objectives)	this.selectedObjectives = routeParams.objectives;
		if (routeParams.shareClass)	this.selectedShareClass = routeParams.shareClass;
		if (routeParams.showIndices) this.showIndices = routeParams.showIndices;
		if (routeParams.timeSpan) this.timeSpan = routeParams.timeSpan;
		//defaulting the share class based on objective: CG-16722
		if (this.selectedObjectives.includes('Managed Risk') || this.selectedObjectives.includes('Portfolio Series')) this.selectedShareClass = 'P2';
		const currentFilters = {
			objectives: this.selectedObjectives.join(',').replace(/\s+/g, '_'),
			assetTypes: this.selectedAssetTypes.join(',').replace(/\s+/g, '_'),
			shareClass: this.selectedShareClass,
			timeSpan: this.timeSpan,
			showIndices: this.showIndices ? 'true' : 'false'
		};
		F2.Events.emit('returns_page_current_filters', JSON.stringify(currentFilters));
	}
};
</script>
